import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import Cookies from 'yoda-interfaces/lib/helpers/Cookies';
import { takeLatest, put, select } from 'redux-saga/effects';
import CustomErrorLogger from '../helpers/CustomErrorLogger/CustomErrorLogger';
import getPageType from '../helpers/Utils/pageType';
import { LOG_CLIENT_ERROR } from '../actionTypes/ClientLoggerActionTypes';
import { ACCOUNT_ID, DP_USER_STATE } from '../common/Constants';
import { selectContext } from '../selectors/ContextSelector';

function* logError(action) {
    const { payload: { errorType = '', errorDescription = '' } = {} } = action;
    const { cluster } = yield select(selectContext);
    const accId = TokenProvider.get(ACCOUNT_ID);
    const userState = TokenProvider.get(DP_USER_STATE);
    const qmSessionId = Cookies.getCookie('QuantumMetricSessionID');
    const cloud = cluster;

    const modifiedErrorType = `Error type=${errorType} |
    account id=${accId} | userState=${userState} | qmSessionId=${qmSessionId}`;

    const modifiedErrorDescription = `Error description=${errorDescription} | cloud-origin=${cloud}`;

    const errorDetails = {
        errorType: modifiedErrorType,
        errorDescription: modifiedErrorDescription,
        pageType: getPageType(),
    };
    yield put(CustomErrorLogger.triggerCustomErrorLog(errorDetails));
}

const clientLoggerSaga = function* clientLoggerSaga() {
    yield takeLatest(LOG_CLIENT_ERROR, logError);
};

clientLoggerSaga.sagaName = 'clientLoggerSaga';

export default clientLoggerSaga;
